export const ANIMATION_DURATION_MS = 150;

const STANDARD_TIMING_FUNCTION = 'cubic-bezier(0.23, 1, 0.32, 1)';
const STANDARD_DURATION = `${ANIMATION_DURATION_MS}ms`;
const STANDARD_DELAY = '0s';

type AnimationTransitionConfig = {
  duration?: string;
  timingFunction?: string;
  delay?: string;
};

type AnimationTransitionArgs = [...properties: string[]] | [...properties: string[], config: AnimationTransitionConfig];

export function animationTransition(...args: AnimationTransitionArgs): string {
  let properties: string[] = [];
  let config: AnimationTransitionConfig = {};

  if (typeof args[args.length - 1] !== 'string') {
    config = args[args.length - 1] as AnimationTransitionConfig;
    properties = args.slice(0, -1) as string[];
  } else {
    properties = args as string[];
  }

  if (!properties.length) {
    throw new Error('Must pass one property to transition');
  }

  const duration = config.duration || STANDARD_DURATION;
  const timingFunction = config.timingFunction || STANDARD_TIMING_FUNCTION;
  const delay = config.delay || STANDARD_DELAY;

  return properties.map(property => `${property} ${duration} ${timingFunction} ${delay}`).join(', ');
}
